import { Card } from '@nike/eds'

export const Unauthorized = () => {
  return (
    <Card className="alignMiddle"></Card>
  )
}
